"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZGiftCardSelect = exports.ZSupportedGiftCardProviders = exports.SupportedGiftCardProviders = void 0;
const types_1 = require("@daymade/common-lib/types");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
const zod_1 = require("zod");
exports.SupportedGiftCardProviders = ['GIFTCLOUD'];
exports.ZSupportedGiftCardProviders = zod_1.z.enum(exports.SupportedGiftCardProviders);
exports.ZGiftCardSelect = zodSchemas_generated_1.zodSelectIntegratedGiftCard.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectIntegratedGiftCard.shape, {
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    expiresAt: zod_1.z.coerce.date().nullable(),
}));
//# sourceMappingURL=models.js.map